/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { FormLabel, Grid, Tooltip, Typography } from "@mui/material";
import classes from "./TenantUserPage.module.css";

interface RepeatedComponentProps {
  label: string;
  detail: string;
  gridsize: number;
}

const RepeatedComponent: React.FC<RepeatedComponentProps> = ({
  label,
  detail,
  gridsize,
}) => {
  return (
    <>
      <Grid container direction="column" xs={gridsize} md={gridsize}>
        <FormLabel className={classes.labelHeading}>{label}</FormLabel>
        <Tooltip title={detail} placement="bottom-start">
          <Typography
            sx={{
              paddingTop: "0.5vh",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            noWrap
            className={classes.labelValue}
          >
            {detail}
          </Typography>
        </Tooltip>
      </Grid>
    </>
  );
};
export default RepeatedComponent;
